var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgMapPin = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 30,
  height: 30,
  viewBox: "0 0 30 30",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M26.25 12.5C26.25 21.25 15 28.75 15 28.75S3.75 21.25 3.75 12.5a11.25 11.25 0 1 1 22.5 0Z",
  stroke: "#fff",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M15 16.25a3.75 3.75 0 1 0 0-7.5 3.75 3.75 0 0 0 0 7.5Z",
  stroke: "#fff",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));

export { SvgMapPin as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzAiIGhlaWdodD0iMzAiIHZpZXdCb3g9IjAgMCAzMCAzMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTI2LjI1IDEyLjVDMjYuMjUgMjEuMjUgMTUgMjguNzUgMTUgMjguNzVDMTUgMjguNzUgMy43NSAyMS4yNSAzLjc1IDEyLjVDMy43NSA5LjUxNjMxIDQuOTM1MjYgNi42NTQ4MyA3LjA0NTA1IDQuNTQ1MDVDOS4xNTQ4MyAyLjQzNTI2IDEyLjAxNjMgMS4yNSAxNSAxLjI1QzE3Ljk4MzcgMS4yNSAyMC44NDUyIDIuNDM1MjYgMjIuOTU1IDQuNTQ1MDVDMjUuMDY0NyA2LjY1NDgzIDI2LjI1IDkuNTE2MzEgMjYuMjUgMTIuNVoiIHN0cm9rZT0id2hpdGUiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik0xNSAxNi4yNUMxNy4wNzExIDE2LjI1IDE4Ljc1IDE0LjU3MTEgMTguNzUgMTIuNUMxOC43NSAxMC40Mjg5IDE3LjA3MTEgOC43NSAxNSA4Ljc1QzEyLjkyODkgOC43NSAxMS4yNSAxMC40Mjg5IDExLjI1IDEyLjVDMTEuMjUgMTQuNTcxMSAxMi45Mjg5IDE2LjI1IDE1IDE2LjI1WiIgc3Ryb2tlPSJ3aGl0ZSIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9zdmc+Cg==";